const SimpleModal = ({ children, show, setShow, additionalClasses }) => {
  const content = show && (
    <div className={"lexcms-modal" + ` ${additionalClasses}` }>
      <div className="lexcms-modal-header">
        <div
          className="lexcms-modal-close"
          type="button"
          onClick={() => setShow(false)}
        >
          Close
        </div>
      </div>
      <div className="lexcms-modal-content">{children}</div>
    </div>
  );

  return content;
};

export default SimpleModal;
